export const arbitrumOneChainId = 42161;
